import React, { useEffect, useRef, useContext, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify } from "../../utils";
import { FontSizeContext } from "../../context/fontSizeContext";

const NewsGrid = ({ data, classOption }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        console.log("fontSize", fontSize);
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <li className="blog-card">
            <Link
                to={process.env.PUBLIC_URL + `/news-details/${data.id}`}
                key={data.id}
            >
                <div
                    className="feature-card d-flex flex-column overflow-hidden w-100 shadow mb-2 report-box "
                    style={{
                        height: "350px",
                        borderRadius: "0.75rem",
                    }}
                >
                    <div className="pb-5">
                        <img
                            // src={award.gridImage}
                            src={`${process.env.PUBLIC_URL}/${data.media.gridImage}`}
                            // alt={`News ${data.id}`}
                            alt=""
                            className="w-100"
                            style={{
                                width: 100,
                                borderRadius: "0.75rem",
                                // objectFit: "cover",
                            }}
                        />
                    </div>

                    <div className="px-3 pb-2">
                        <span style={{ fontSize: "13px", color: "#636363" }}>
                            {data.author}: {data.date}
                        </span>
                    </div>

                    <div className="px-3">
                        <p className="widget-sub-title" title={data.title}>
                            {data.title.slice(0, 70)} ...
                        </p>
                    </div>
                </div>
            </Link>
        </li>
    );
};

NewsGrid.propTypes = {
    data: PropTypes.object,
    classOption: PropTypes.string,
};

NewsGrid.defaultProps = {
    classOption: "thumb",
};

export default NewsGrid;
